var _sodipodiNamedview, _defs, _sodipodiNamedview2, _rect, _path, _rect2, _polygon, _rect3, _polygon2, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _circle, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _metadata;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRural(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 808.28827 531.00001",
    id: "svg152",
    sodipodiDocname: "rural2.svg",
    inkscapeVersion: "1.1.2 (b8e25be833, 2022-02-05)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview65",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    inkscapeZoom: 1.1465309,
    inkscapeCx: 403.39077,
    inkscapeCy: 265.14766,
    "inkscapeWindow-width": 1680,
    "inkscapeWindow-height": 987,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg152"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs156"
  })), _sodipodiNamedview2 || (_sodipodiNamedview2 = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview154",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    inkscapeZoom: 0.96921724,
    inkscapeCx: 519.49138,
    inkscapeCy: 265.16243,
    "inkscapeWindow-width": 1680,
    "inkscapeWindow-height": 987,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg152"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "buy_house") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160.92931,
    y: 177.43181,
    width: 8.9026203,
    height: 351.65344,
    fill: "#3f3d56",
    id: "rect18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 251.993,222.246 c 0.56672,122.96444 -85.94527,223.04766 -85.94527,223.04766 0,0 -87.43083,-99.28154 -87.99756,-222.246 C 77.48344,100.0832 163.99544,0 163.99544,0 c 0,0 87.43082,99.28156 87.99756,222.246 z",
    fill: "#1a84ee",
    id: "path20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.28825,
    y: 383.50003,
    width: 689,
    height: 146,
    fill: "#f2f2f2",
    id: "rect22"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "877.5,242.5 933.5,399.5 203.5,399.5 278.5,242.5 ",
    fill: "#3f3d56",
    id: "polygon24",
    transform: "translate(-125.21174,2e-5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265.28827,
    y: 252.50002,
    width: 278,
    height: 92,
    fill: "#f2f2f2",
    id: "rect26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "694.5,269.5 668.5,177.5 408.5,177.5 364.5,269.5 ",
    fill: "#3f3d56",
    id: "polygon28",
    transform: "translate(-125.21174,2e-5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 412.50003,
    width: 219.5,
    height: 117,
    fill: "#cccccc",
    id: "rect30"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 416.50003,
    width: 117,
    height: 113,
    fill: "#cccccc",
    id: "rect32"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 547.28821,
    y: 423.50003,
    width: 60.5,
    height: 106,
    fill: "#3f3d56",
    id: "rect34"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 529,
    width: 780,
    height: 2,
    fill: "#3f3d56",
    id: "rect36",
    x: 20.788261,
    style: {
      strokeWidth: 0.82826
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.693161,
    y: 297.05887,
    width: 5.8747702,
    height: 232.0535,
    fill: "#3f3d56",
    id: "rect38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 114.78541,326.6314 c 0.374,81.14332 -56.71464,147.18749 -56.71464,147.18749 0,0 -57.69500096,-65.51515 -58.06894096,-146.65847 -0.37394,-81.14332 56.71464096,-147.1875 56.71464096,-147.1875 0,0 57.69496,65.51518 58.06894,146.65848 z",
    fill: "#1a84ee",
    id: "path40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 114.78541,326.6314 c 0.374,81.14332 -56.71464,147.18749 -56.71464,147.18749 0,0 -57.69500096,-65.51515 -58.06894096,-146.65847 -0.37394,-81.14332 56.71464096,-147.1875 56.71464096,-147.1875 0,0 57.69496,65.51518 58.06894,146.65848 z",
    opacity: 0.1,
    id: "path42"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 673.28821,
    y: 429.50003,
    width: 29.5,
    height: 27.5,
    fill: "#3f3d56",
    id: "rect48"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 712.78821,
    y: 429.50003,
    width: 29.5,
    height: 27.5,
    fill: "#3f3d56",
    id: "rect50"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 673.28821,
    y: 467.00003,
    width: 29.5,
    height: 28.5,
    fill: "#3f3d56",
    id: "rect52"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 712.78821,
    y: 467.00003,
    width: 29.5,
    height: 28.5,
    fill: "#3f3d56",
    id: "rect54"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 290.78827,
    y: 277.67395,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56",
    id: "rect56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 321.70129,
    y: 277.67395,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56",
    id: "rect58"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 290.78827,
    y: 307.02176,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56",
    id: "rect60"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 321.70129,
    y: 307.02176,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56",
    id: "rect62"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 463.78824,
    y: 277.67395,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56",
    id: "rect64"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 494.70126,
    y: 277.67395,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56",
    id: "rect66"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 463.78824,
    y: 307.02176,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56",
    id: "rect68"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 494.70126,
    y: 307.02176,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56",
    id: "rect70"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 377.78827,
    y: 277.67395,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56",
    id: "rect72"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 408.70129,
    y: 277.67395,
    width: 23.08696,
    height: 21.52174,
    fill: "#3f3d56",
    id: "rect74"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 377.78827,
    y: 307.02176,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56",
    id: "rect76"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 408.70129,
    y: 307.02176,
    width: 23.08696,
    height: 22.30435,
    fill: "#3f3d56",
    id: "rect78"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 560.78821,
    y: 434.23917,
    width: 14.53623,
    height: 13.55072,
    fill: "#f2f2f2",
    id: "rect80"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 580.25195,
    y: 434.23917,
    width: 14.53623,
    height: 13.55072,
    fill: "#f2f2f2",
    id: "rect82"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 560.78821,
    y: 452.71741,
    width: 14.53623,
    height: 14.04348,
    fill: "#f2f2f2",
    id: "rect84"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 580.25195,
    y: 452.71741,
    width: 14.53623,
    height: 14.04348,
    fill: "#f2f2f2",
    id: "rect86"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 599.78821,
    cy: 484.00003,
    r: 4,
    fill: "#f2f2f2",
    id: "circle88"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 425.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect90"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 434.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect92"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 443.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect94"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 452.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect96"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 461.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect98"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 470.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect100"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 479.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect102"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 488.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect104"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 497.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect106"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 506.00003,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect108"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 289.78827,
    y: 515,
    width: 220,
    height: 2,
    fill: "#f2f2f2",
    id: "rect110"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 425.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect112"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 434.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect114"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 443.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect116"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 452.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect118"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 461.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect120"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 470.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect122"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 479.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect124"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 488.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect126"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 497.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect128"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 506.00003,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect130"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 127.28825,
    y: 515,
    width: 117,
    height: 2,
    fill: "#f2f2f2",
    id: "rect132"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1497"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcTitle", null, "buy_house"))), /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcTitle", null, "buy_house"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRural);
export default __webpack_public_path__ + "static/media/rural.4553a4539d3b0110e72849cfee3ce9cf.svg";
export { ForwardRef as ReactComponent };